// ============================================================
//  src/app/bindings.js — Registro centralizado de eventos UI
// ============================================================

import {
    iniciarSesionConGoogle,
    cerrarSesion,
    registrarConEmail,
    iniciarSesionConEmail,
    recuperarContrasena
} from '../auth.js';

import {
    abrirModalCrear,
    cerrarModal,
    manejarSubmitFormulario
} from '../modal.js';

import {
    cerrarModalAutorizacion,
    manejarAutorizarDrive
} from '../modal-autorizar-drive.js';

import {
    cerrarModalArchivos,
    manejarSeleccionArchivo
} from '../modal-drive.js';

import {
    abrirPanelPerfil,
    cerrarPanelPerfil,
    manejarGuardarPerfil,
    abrirModalEliminarCuenta,
    cerrarModalEliminarCuenta,
    verificarConfirmacionEliminar,
    manejarEliminarCuenta,
    cerrarModalAccesoManaged,
    manejarSolicitarAccesoManaged,
    cerrarModalCambioStorage,
    manejarSolicitarCambioStorage
} from '../perfil.js';

import { auth } from '../firebase.js';
import { cambiarIdioma } from '../i18n.js';
import { guardarIdiomaEnPerfil } from '../perfil-datos.js';
import { getPerfilActual } from '../perfil.js';
import { getUltimasEdiciones } from '../dashboard.js';
import { actualizarPerfilPublico } from '../public-profile.js';
import { abrirModalSolicitud, cerrarModalSolicitud } from '../solicitud.js';
import {
    abrirModalSugerencia,
    cerrarModalSugerencia,
    manejarEnviarSugerencia,
    abrirModalAcercaDe,
    cerrarModalAcercaDe
} from '../footer.js';
import { abrirShack, cerrarShack } from '../shack/shack.js';
import { toggleNotificaciones, manejarMarcarTodasLeidas,
         cerrarDropdownNotificaciones } from '../notifications.js';
import { cerrarModalModeracion, aprobarModeracion,
         rechazarModeracion,
         cerrarModalManagedDrive, aprobarAccesoManagedDrive,
         rechazarAccesoManagedDrive } from '../admin.js';

import {
    byId,
    onClick,
    onChange,
    onInput,
    onSubmit,
    onOverlayClose
} from './dom.js';

function _sincronizarIdiomaPublico(usuario, nuevoIdioma) {
    const perfil = getPerfilActual();
    if (!perfil?.indicativoOperador) return;
    const p = { ...perfil, preferencias: { ...(perfil.preferencias ?? {}), idioma: nuevoIdioma } };
    actualizarPerfilPublico(usuario.uid, p, getUltimasEdiciones()).catch(console.error);
}

function bindIdioma() {
    onClick('btn-idioma-es', async () => {
        cambiarIdioma('es');
        const usuario = auth.currentUser;
        if (usuario) {
            await guardarIdiomaEnPerfil(usuario.uid, 'es');
            _sincronizarIdiomaPublico(usuario, 'es');
        }
    });

    onClick('btn-idioma-en', async () => {
        cambiarIdioma('en');
        const usuario = auth.currentUser;
        if (usuario) {
            await guardarIdiomaEnPerfil(usuario.uid, 'en');
            _sincronizarIdiomaPublico(usuario, 'en');
        }
    });
}

function bindLoginGoogle() {
    onClick('btn-login', iniciarSesionConGoogle);
}

function bindLoginEmailYRegistro() {
    onClick('btn-login-email', () => {
        const email = byId('login-email')?.value.trim();
        const contrasena = byId('login-contrasena')?.value;
        iniciarSesionConEmail(email, contrasena);
    });

    onClick('btn-registrar', () => {
        const nombre = byId('login-nombre')?.value.trim();
        const email = byId('login-email')?.value.trim();
        const contrasena = byId('login-contrasena')?.value;
        registrarConEmail(nombre, email, contrasena);
    });

    onClick('btn-recuperar-contrasena', () => {
        const email = byId('login-email')?.value.trim();
        recuperarContrasena(email);
    });
}

function bindTabsLoginRegistro() {
    onClick('tab-login', () => {
        byId('tab-login')?.classList.add('login-tab--activo');
        byId('tab-registro')?.classList.remove('login-tab--activo');

        if (byId('campo-nombre-wrapper')) byId('campo-nombre-wrapper').style.display = 'none';
        if (byId('btn-login-email')) byId('btn-login-email').style.display = '';
        if (byId('btn-registrar')) byId('btn-registrar').style.display = 'none';
        if (byId('btn-recuperar-contrasena')) byId('btn-recuperar-contrasena').style.display = '';
        if (byId('login-contrasena')) byId('login-contrasena').autocomplete = 'current-password';
    });

    onClick('tab-registro', () => {
        byId('tab-registro')?.classList.add('login-tab--activo');
        byId('tab-login')?.classList.remove('login-tab--activo');

        if (byId('campo-nombre-wrapper')) byId('campo-nombre-wrapper').style.display = '';
        if (byId('btn-login-email')) byId('btn-login-email').style.display = 'none';
        if (byId('btn-registrar')) byId('btn-registrar').style.display = '';
        if (byId('btn-recuperar-contrasena')) byId('btn-recuperar-contrasena').style.display = 'none';
        if (byId('login-contrasena')) byId('login-contrasena').autocomplete = 'new-password';
    });
}

function bindNavbar() {
    onClick('btn-configuracion',    abrirPanelPerfil);
    onClick('navbar-nombre-usuario', abrirPanelPerfil);
    onClick('btn-salir', cerrarSesion);
}

function bindDashboard() {
    onClick('btn-nuevo-concurso', abrirModalCrear);
    onClick('btn-abrir-shack', abrirShack);
}

function bindModalConcurso() {
    onClick('btn-cerrar-modal', cerrarModal);
    onClick('btn-cancelar-concurso', cerrarModal);
    onOverlayClose('modal-concurso', cerrarModal);
    onSubmit('form-concurso', manejarSubmitFormulario);
}

function bindModalDrive() {
    onClick('btn-cerrar-modal-drive', cerrarModalAutorizacion);
    onClick('btn-cancelar-drive', cerrarModalAutorizacion);
    onClick('btn-autorizar-drive', manejarAutorizarDrive);
    onOverlayClose('modal-autorizar-drive', cerrarModalAutorizacion);

    onClick('btn-cerrar-modal-archivos', cerrarModalArchivos);
    onOverlayClose('modal-archivos', cerrarModalArchivos);

    onChange('input-archivo-drive', manejarSeleccionArchivo);

    onClick('btn-subir-archivo', () => {
        byId('input-archivo-drive')?.click();
    });
}

function bindPerfil() {
    onClick('btn-cerrar-perfil',  cerrarPanelPerfil);
    onClick('btn-salir-perfil',   cerrarSesion);
    onOverlayClose('panel-perfil', cerrarPanelPerfil);
    onSubmit('form-perfil', manejarGuardarPerfil);

    onClick('btn-eliminar-cuenta', abrirModalEliminarCuenta);
    onClick('btn-cancelar-eliminar-cuenta', cerrarModalEliminarCuenta);
    onInput('campo-confirmar-eliminar', verificarConfirmacionEliminar);
    onClick('btn-confirmar-eliminar-cuenta', manejarEliminarCuenta);

    onClick('btn-cerrar-acceso-managed',   cerrarModalAccesoManaged);
    onClick('btn-cancelar-acceso-managed', cerrarModalAccesoManaged);
    onClick('btn-enviar-acceso-managed',   manejarSolicitarAccesoManaged);
    onOverlayClose('modal-acceso-managed', cerrarModalAccesoManaged);

    onClick('btn-cerrar-cambio-storage',   cerrarModalCambioStorage);
    onClick('btn-cancelar-cambio-storage', cerrarModalCambioStorage);
    onClick('btn-enviar-cambio-storage',   manejarSolicitarCambioStorage);
    onOverlayClose('modal-cambio-storage', cerrarModalCambioStorage);
}

function bindShack() {
    onClick('btn-cerrar-shack', cerrarShack);
    onOverlayClose('modal-shack', cerrarShack);
}

function bindNotificaciones() {
    onClick('btn-notificaciones', toggleNotificaciones);
    onClick('btn-marcar-leidas', manejarMarcarTodasLeidas);
}

function bindModeracion() {
    onClick('btn-cerrar-moderacion', cerrarModalModeracion);
    onClick('btn-mod-aprobar', aprobarModeracion);
    onClick('btn-mod-rechazar', rechazarModeracion);
    onOverlayClose('modal-moderacion', cerrarModalModeracion);
}

function bindManagedDrive() {
    onClick('btn-cerrar-managed-drive', cerrarModalManagedDrive);
    onClick('btn-md-aprobar', aprobarAccesoManagedDrive);
    onClick('btn-md-rechazar', rechazarAccesoManagedDrive);
    onOverlayClose('modal-managed-drive', cerrarModalManagedDrive);
}

function bindFooterYSolicitudes() {
    onClick('btn-sugerencia', abrirModalSugerencia);
    onClick('btn-cerrar-sugerencia', cerrarModalSugerencia);
    onClick('btn-cancelar-sugerencia', cerrarModalSugerencia);
    onOverlayClose('modal-sugerencia', cerrarModalSugerencia);
    onSubmit('form-sugerencia', manejarEnviarSugerencia);

    onClick('btn-acerca-de', abrirModalAcercaDe);
    onClick('btn-cerrar-acerca-de', cerrarModalAcercaDe);
    onClick('btn-cerrar-acerca-de-ok', cerrarModalAcercaDe);
    onOverlayClose('modal-acerca-de', cerrarModalAcercaDe);

    onClick('btn-cerrar-solicitud', cerrarModalSolicitud);
    onClick('btn-cancelar-solicitud', cerrarModalSolicitud);
    onOverlayClose('modal-solicitud', cerrarModalSolicitud);
}

function bindEscapeGlobal() {
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        cerrarModal();
        cerrarModalAutorizacion();
        cerrarModalArchivos();
        cerrarPanelPerfil();
        cerrarModalEliminarCuenta();
        cerrarModalSugerencia();
        cerrarModalAcercaDe();
        cerrarModalSolicitud();
        cerrarModalAccesoManaged();
        cerrarModalCambioStorage();
        cerrarShack();
        cerrarDropdownNotificaciones();
        cerrarModalModeracion();
        cerrarModalManagedDrive();
    });
}

export function registrarTodosLosEventos() {
    bindIdioma();
    bindLoginGoogle();
    bindLoginEmailYRegistro();
    bindTabsLoginRegistro();
    bindNavbar();
    bindDashboard();
    bindModalConcurso();
    bindModalDrive();
    bindPerfil();
    bindShack();
    bindNotificaciones();
    bindModeracion();
    bindManagedDrive();
    bindFooterYSolicitudes();
    bindEscapeGlobal();
}